<template>
  <div class="card modal-overflow" style="box-shadow: none;">
    <div class="card-body new-job">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label>Job Name</label>
            <div class="job-view-fields grey-font">
              <h6>
                {{ job.name }}
                <span v-if="job.actualCompletionDate">
                  - Completed on: {{ job.actualCompletionDate | formatDate }}
                </span>
              </h6>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <label>&nbsp</label>
          <img @click.stop="viewFiles" v-if="canReadFiles" src="static/img/icon-folder.png" title="Job Files" class="files-icon"/>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Job Number</label>
            <div class="job-view-fields grey-font">
              {{ job.number }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Inv. By Job Number</label>
            <div class="job-view-fields grey-font" v-if="job != null">
              {{ job.invoiceByJobNumber | printBool }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Job Coordinator</label>
            <div class="job-view-fields grey-font">
              {{ job.coordinator }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Job Priority</label>
            <div class="job-view-fields grey-font">
              {{ priorityValueToLabel(job.priority) }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Job Status</label>
            <div class="job-view-fields grey-font">
              {{ job.status }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Elevation</label>
            <div class="job-view-fields grey-font">
              {{ job.elevation }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Billable Client</label>
            <div class="job-view-fields grey-font">
              {{ lodash.get(job, 'client.name') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Client Contact</label>
            <div class="job-view-fields grey-font">
              {{ lodash.get(job, 'clientContact.name') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Builder</label>
            <div class="job-view-fields grey-font">
              {{ lodash.get(job, 'builder.name') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Builder Contact</label>
            <div class="job-view-fields grey-font">
              {{ lodash.get(job, 'builderContact.name') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Community</label>
            <div class="job-view-fields grey-font">
              {{ lodash.get(job, 'community.name') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Plan Name</label>
            <div class="job-view-fields grey-font">
                {{ job.planName }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Date Received</label>
            <div class="job-view-fields grey-font">
              {{ job.dateReceived | formatDate }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Target Completion Date</label>
            <div class="job-view-fields grey-font">
              {{ job.targetCompletionDate | formatDate }}
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="job.description">
        <div class="col-md-12">
          <div class="form-group">
            <label>Description</label>
            <div class="job-view-fields grey-font">
              <div v-html="job.description">-</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h6>Tasks</h6>
          <el-table class="table-striped wrap-whole-words"
                    :data="tasks"
                    border
                    style="width: 100%">
            <el-table-column
              :min-width="200"
              label="Task Name">
              <template v-slot="props">
                {{ taskNameWithOptionalRepeatCountSuffix(props.row) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              prop="status"
              label="Status">
            </el-table-column>
            <el-table-column
              :min-width="200"
              prop="assignee"
              label="Assignee">
              <template v-slot="props">
                {{ getUserDisplayName(props.row.assigneeId) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="200"
              prop="dueDate"
              label="Due Date">
              <template slot-scope="props">
                {{ lodash.get(props.row, 'dueDate') | formatDate }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {NOT_FOUND, OK} from 'http-status-codes'
import {
  assemblePlanNameDisplay,
  getUserFullName,
  notifyError,
  objectById,
  priorityLabel,
  fileSystemPath,
  taskNameWithOptionalRepeatCountSuffix
} from 'src/utilities/utils'
import {getCompanies} from 'src/utilities/ptracApiHelper'
import lodash from 'lodash'
import Permissions from 'src/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    users() {
      return this.$store.get('users/results')
    },
    canReadFiles() {
      return this.$can('read', Permissions.FILES);
    }
  },
  data() {
    return {
      lodash,
      job: {},
      tasks: []
    }
  },
  methods: {
    taskNameWithOptionalRepeatCountSuffix,
    priorityValueToLabel(value) {
      return priorityLabel(value)
    },
    getUserDisplayName(userId) {
      return this.$store.getters['users/displayName'](userId)
    },
    async viewFiles() {
      const departmentResponse = await this.$store.dispatch('departments/fetchById', this.job.departmentId)
      if (OK !== departmentResponse.status) {
        notifyError(this, "Failed to load department by ID: " + this.job.departmentId)
        return
      }

      const projectResponse = await this.$store.dispatch('projects/fetchById', this.job.projectId)
      if (OK !== projectResponse.status) {
        notifyError(this, "Failed to load project by ID: " + this.job.projectId)
        return
      }

      const path = fileSystemPath(projectResponse.data.name, this.job.projectId, departmentResponse.data.name, this.job.name, this.job.id)
      this.$eventHub.$emit('show-modal-4', 'File Browser', path, '600px')
    }
  },
  async mounted() {
    const response = await this.$store.dispatch('fetchById', {
      'endpoint': 'jobs',
      'id': this.data.id
    })

    if (OK === response.status) {
      this.job = response.data
      const companies = await getCompanies([this.job], 'clientId', 'builderId')

      this.job.client = objectById(companies, this.job.clientId)
      this.job.builder = objectById(companies, this.job.builderId)

      if (this.job.clientContactId && this.job.client) {
        this.job.clientContact = objectById(this.job.client.contacts, this.job.clientContactId)
      }

      if (this.job.builderContactId && this.job.builder) {
        this.job.builderContact = objectById(this.job.builder.contacts, this.job.builderContactId)
      }

      const coordinator = objectById(this.users, this.job.coordinatorId)
      if (coordinator) {
        this.job.coordinator = getUserFullName(coordinator)
      }

      if (this.job.communityId) {
        const communitiesResponse = this.$store.dispatch('fetchById', {
          'endpoint': 'communities',
          'id': this.job.communityId
        })

        if (OK === response.status) {
          this.job.community = communitiesResponse.data.name
        }
      }

      if (this.job.planNameId) {
        const planNamesResponse = this.$store.dispatch('fetchById', {
          'endpoint': 'plan-names',
          'id': this.job.planNameId
        })

        if (OK === response.status) {
          this.job.planName = assemblePlanNameDisplay(planNamesResponse.data)
        }
      }

      // load a Job's tasks
      const tasksResponse = await this.$store.dispatch('tasks/fetchTasksByJobId', this.job.id)
      if (OK === tasksResponse.status) {
        this.tasks = tasksResponse.data
      }
      this.$forceUpdate() // don't remove - not working reliably without this
    } else if (NOT_FOUND === response.status) {
      notifyError(this, 'Failed to load job. Job with ID: ' + this.data.id + ' was not found')
    } else {
      notifyError(this, 'Failed to load job')
    }
  }
}
</script>

<style scoped>
  .job-view-fields {
    background-color: lightgrey;
    padding: 11px 0 4px 8px;
    border-radius: 5px;
    min-height: 40px;
  }

  label {
    display: block;
  }

  .files-icon {
    cursor: pointer;
    margin-top: 8px;
  }
</style>
